<script async setup lang="ts">
import { Button } from '@albank/vue-ui-kit';

import { isActualEvent } from '@/helpers/isActualEvent';
import { dateToText } from '@/helpers/dateToText';
import { getImageLink } from '@/helpers/imageLink';
import { ISO8601ToTime } from '@/helpers/isoToTime';
import { parseMarkdown } from '@/helpers/parseMarkdown';
import { useEventStore } from '@/stores/events.store';
import { useModalStore } from '@/stores/signup.store';

const eventStore = useEventStore();
const event = eventStore.getEvent;

const modalStore = useModalStore();
</script>

<template>
  <section class="screen home">
    <div class="home__content">
      <div class="home__content-info">
        <h1>{{ event?.name }}</h1>
        <div
          class="short-description"
          v-html="parseMarkdown(event?.shortDescription ?? null)"
        ></div>
        <Button
          @click="modalStore.toggleModal()"
          v-if="isActualEvent(event?.plannedDateTime)"
          :iconSource="{ right: '/assets/icons/arrow-right.svg' }"
        >
          Зарегистрироваться
        </Button>
      </div>
      <img
        v-if="event"
        :src="getImageLink(event?.imageId)"
        :alt="event?.name"
      />
    </div>

    <div class="home__info">
      <div class="home__info-card" v-if="event?.plannedDateTime">
        <img src="/assets/icons/calendar.svg" alt="" />
        <time>{{ dateToText(event.plannedDateTime) }}</time>
      </div>
      <div class="home__info-card" v-if="event?.time">
        <img src="/assets/icons/time.svg" alt="" />
        <p>Начало в {{ ISO8601ToTime(event.time) }}</p>
      </div>
      <div class="home__info-card" v-if="event?.place">
        <img src="/assets/icons/place.svg" alt="" />
        <p>{{ event.place }}</p>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.home {
  gap: 40px;
  display: flex;
  flex-direction: column;

  &__content {
    gap: 48px;
    display: flex;
    align-items: center;
    // max-height: calc(100vh - 160px);
    justify-content: space-between;

    @media screen and (max-width: 1024px) {
      gap: 60px;
      height: auto;
      flex-direction: column-reverse;
    }

    @media screen and (max-width: 460px) {
      gap: 40px;

      h1 {
        max-width: 100%;
        word-wrap: break-word;
      }
    }

    &-info {
      gap: 40px;
      flex: 1 300px;
      display: flex;
      max-width: 50%;
      flex-direction: column;
      align-items: flex-start;

      @media screen and (max-width: 1024px) {
        max-width: 100%;
      }

      h1 {
        max-width: 100%;
      }

      p {
        max-width: 80%;
        font-size: var(--font-size-s);
        font-weight: var(--font-weight-regular);

        @media screen and (max-width: 460px) {
          max-width: 100%;
        }
      }
    }

    img {
      max-width: calc(50% - 48px);
      flex: 1 300px;
      max-height: 60vh;
      border-radius: 60px;
      object-fit: cover;
      max-height: 100%;

      @media screen and (max-width: 1024px) {
        max-height: 600px;
        width: 100%;
        flex: 1 500px;
        height: 500px;
        max-width: 100%;
      }

      @media screen and (max-width: 430px) {
        height: 400px;
        max-height: 400px;
      }

      @media screen and (max-width: 380px) {
        height: 360px;
        max-height: 360px;
      }
    }
  }

  &__info {
    gap: 24px;
    display: flex;
    padding: 60px 0;
    justify-content: space-between;

    @media screen and (max-width: 1024px) {
      flex-direction: column;
    }

    &-card {
      gap: 24px;
      flex: 1 33%;
      padding: 56px;
      display: flex;
      max-height: 232px;
      align-items: center;
      border-radius: 60px;
      flex-direction: column;
      background: var(--color-mono-10);

      img {
        width: 64px;
      }
      p,
      time {
        text-align: center;
        font-weight: var(--font-weight-bold);

        @media screen and (max-width: 1200px) {
          line-height: 20px;
          font-size: var(--font-size-s);
        }

        @media screen and (max-width: 1024px) {
          line-height: 24px;
          font-size: var(--font-size-md);
        }
      }

      @media screen and (max-width: 1024px) {
        max-height: 272px;
      }
    }
  }
}
</style>
